import { supabase } from "./supabase";
import { fromDbLogEntry, toDbLogEntryInsert } from "../lib/mappers";

const LOG_COLUMNS = "id, dpr_id, timestamp, description";

const listLogEntries = async (dprId) => {
  const { data, error } = await supabase
    .from("detailed_log_entries")
    .select(LOG_COLUMNS)
    .eq("dpr_id", dprId)
    .order("timestamp", { ascending: true });

  if (error) throw error;
  return (data ?? []).map(fromDbLogEntry);
};

const createLogEntry = async (entry) => {
  const payload = toDbLogEntryInsert(entry);
  const { data, error } = await supabase
    .from("detailed_log_entries")
    .insert(payload)
    .select(LOG_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbLogEntry(data);
};

const updateLogEntry = async (id, updates) => {
  const { data, error } = await supabase
    .from("detailed_log_entries")
    .update({
      timestamp: updates.timestamp,
      description: updates.description,
    })
    .eq("id", id)
    .select(LOG_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbLogEntry(data);
};

const deleteLogEntry = async (id) => {
  const { error } = await supabase
    .from("detailed_log_entries")
    .delete()
    .eq("id", id);
  if (error) throw error;
};

export { listLogEntries, createLogEntry, updateLogEntry, deleteLogEntry };
